import React from "react";
import Header from "./components/Header";
import Social from "./components/Social";
import About from "./components/About";
import Accordions from "./components/Accordions";
import TypeWriter from "./components/TypeWriter";
import ImageSwiper from "./components/ImageSwiper";
import Clients from "./components/Clients";
import Share from "./components/Share";
import Footer from "./components/Footer";
import background from "./images/bg.jpg";
import BottomSwiper from "./components/BottomSwiper";
import Admin from "./components/Admin";

function App() {
  if (window.location.pathname.replace(/\/$/, "") === "/admin") return <Admin />;

  var domainUrl = "https://oksicosmetics.netlify.app/";
  var businessName = "Devorah's Lane";
  var businessDescription = "מחירון";
  var phoneNumber = "+972508859558";
  var email = "Oksifreidin35@gmail.com";
  var facebookUrl = "https://www.facebook.com/oksana.fraidin?mibextid=ZbWKwL";
  var instagram = "oksanafreidin";
  var whatsapp = "+972508859558";
  var wazeUrl =
    "https://www.waze.com/he/live-map/directions/%D7%94%D7%A4%D7%A8%D7%97%D7%99%D7%9D-11-%D7%97%D7%99%D7%A4%D7%94?to=place.w.22937928.229313742.71715";
  var days = "ראשון עד שבת";
  var hours = "09:00 - 18:00";
  //קצת עליי
  //טיפולים בקליניקה
  //לקוחות ממליצים
  //icon
  //שם ותיאור

  return (
    <div className="min-h-screen bg-gray-50 pb-20 pattern-dots">
      <div className="max-w-2xl mx-auto min-h-screen bg-white/90 shadow-xl shadow-gray-200/50 backdrop-blur-sm">
        <div className="relative">
          {/* Optional: If we wanted the image as a header banner, we could put it here like:
                 <div className="h-48 w-full bg-cover bg-center" style={{backgroundImage: `url(${background})`}} /> 
                 But for minimal UI, maybe just a clean header is better. 
                 Let's keep it clean for now. 
             */}
          <Header
            businessName={businessName}
            businessDescription={businessDescription}
          />

          <div className="px-4 pb-12">
            <Accordions
              phoneNumber={phoneNumber}
              email={email}
              days={days}
              hours={hours}
            />
          </div>

          {/* <Social ... /> */}
          {/* <About ... /> */}
          {/* <TypeWriter ... /> */}
        </div>
      </div>
    </div>
  );
}

export default App;
